import React from 'react';
import FieldIcon_FormValueNotEmpty from "../components/form/value-not-empty";
import FieldIcon_Popover from "../components/popover/popover";
import {FieldFormElementProps} from "../../../render/form-elemnent";

type State = {
    currentValue    : string
    showPopover     : boolean
}

export default class FieldIcon_FormElement extends React.Component<FieldFormElementProps,State> {

    constructor(props: FieldFormElementProps) {
        super(props);

        this.state = {
            currentValue    : this.props.field.getViewValue(props.model),
            showPopover     : false,
        }
    }

    showPopover = (e?:React.SyntheticEvent) => {
        e?.stopPropagation()

        if (!this.props.disabled) {
            this.setState({showPopover: true})
        }
    }

    hidePopover = () => {
        this.setState({showPopover: false})
    }


    onChange = (icon: string) => {

        this.setState({currentValue: icon})

        if (this.props.form) {
            this.props.form.onFormComponentValueChange(this.props.field.fieldId, icon)
        }
    }

    render() {
        const {field}   = this.props;

        const classes= Classes(this.props.className, {
            'show-popover'  : this.state.showPopover,
            'is-disabled'   : this.props.disabled
        });

        return (
            <FieldIcon_FormValueNotEmpty className  = {classes}
                                         field      = {field}
                                         size       = {this.props.options?.size}
                                         value      = {this.state.currentValue}
                                         disabled   = {this.props.disabled}
                                         onClick    = {this.showPopover}>
                {this.state.showPopover &&
                    <FieldIcon_Popover parent       = {this}
                                       field        = {this.props.field}
                                       hidePopover  = {this.hidePopover}
                                       value        = {this.state.currentValue}
                                       onChange     = {this.onChange}/>
                }
            </FieldIcon_FormValueNotEmpty>
        );
    }
}
